/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import InfoAction from './InfoAction/index'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import TysiaSelectOneValues from 'DesignSystem/TysiaSelectOne/TysiaSelectOneValues/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/EditAutomation/TriggerType/AppointmentBookingsStateUpdate/Content/SourceTypes/Content",
  onChange
  
}) {
let sourceTypesValueData = fromData.useDataValue({ viewPath,
context: 'source_types',
})
let automationSourceTypesValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'source_types',
})
let automationSourceTypesChangeData = fromData.useDataChange({ viewPath,
context: 'automation',
path: 'source_types',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="from"
/>
</div>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 marginTop={0}
 alignSelf="start"
 data="source_types"
 from={sourceTypesValueData}
 data="automation.source_types"
 value={automationSourceTypesValueData}
 onChange={automationSourceTypesChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
 flexGrow={0}
 maxWidth={260}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
<TysiaSelectOneValues
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneValues`}
/>
</React.Fragment>
)}
</TysiaSelectOne>
<InfoAction
  viewPath={`${viewPath}/InfoAction`}
/>
{children}
</React.Fragment>)
}